import { render, staticRenderFns } from "./DueDate.vue?vue&type=template&id=335a1ab6&scoped=true"
import script from "./DueDate.vue?vue&type=script&lang=js"
export * from "./DueDate.vue?vue&type=script&lang=js"
import style0 from "./DueDate.vue?vue&type=style&index=0&id=335a1ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335a1ab6",
  null
  
)

export default component.exports